import { CalendarClock, FileText, Home, IdCard, LifeBuoy, ScrollText, UserRound, UtensilsCrossed, Users, Wallet, Wrench } from 'lucide-react';
import type { NavGroup, PaletteCommand } from './types';

/** Resident app: pay first, then everything about daily life in the building. */
export const tenantNav: readonly NavGroup[] = [
  {
    id: 'home',
    items: [
      { id: 'home', label: 'Home', to: '/tenant', icon: Home, end: true, tab: true, keywords: ['dashboard', 'overview'] },
      { id: 'pay', label: 'Pay', to: '/tenant/pay', icon: Wallet, tab: true, keywords: ['rent', 'dues', 'receipts', 'passbook', 'upi'] },
    ],
  },
  {
    id: 'stay',
    label: 'Stay',
    items: [
      { id: 'meals', label: 'Meals', to: '/tenant/meals', icon: UtensilsCrossed, tab: true, tabLabel: 'Stay', keywords: ['food', 'mess', 'attendance', 'menu'] },
      { id: 'issues', label: 'Issues', to: '/tenant/issues', icon: Wrench, keywords: ['complaint', 'repair', 'raise'] },
      { id: 'passes', label: 'Passes', to: '/tenant/passes', icon: CalendarClock, keywords: ['leave', 'late pass', 'gate pass', 'guest'] },
      { id: 'community', label: 'Community', to: '/tenant/community', icon: Users, keywords: ['notices', 'wifi', 'warden', 'contacts', 'announcements'] },
    ],
  },
  {
    id: 'me',
    label: 'Me',
    items: [
      { id: 'profile', label: 'Profile', to: '/tenant/profile', icon: UserRound, keywords: ['account', 'kyc', 'documents', 'aadhaar'] },
      { id: 'tenancy', label: 'My tenancy', to: '/tenant/tenancy', icon: ScrollText, keywords: ['agreement', 'deposit', 'notice', 'move out', 'lease'] },
      { id: 'help', label: 'Help', to: '/tenant/help', icon: LifeBuoy, keywords: ['support', 'contact'] },
    ],
  },
];

export const tenantCommands: readonly PaletteCommand[] = [
  { id: 'pay-now', label: 'Pay rent', to: '/tenant/pay', icon: Wallet, keywords: ['dues', 'upi'] },
  { id: 'raise-issue', label: 'Raise an issue', to: '/tenant/issues?new=1', icon: Wrench, keywords: ['complaint'] },
  { id: 'late-pass', label: 'Request a late pass', to: '/tenant/passes?new=late', icon: CalendarClock, keywords: ['gate'] },
  { id: 'mark-leave', label: 'Mark leave', to: '/tenant/passes?new=leave', icon: CalendarClock, keywords: ['away', 'vacation'] },
  { id: 'agreement', label: 'View agreement', to: '/tenant/tenancy', icon: FileText, keywords: ['lease', 'sign'] },
  { id: 'kyc', label: 'Complete KYC', to: '/tenant/profile', icon: IdCard, keywords: ['aadhaar', 'documents'] },
];
